export default __webpack_public_path__ + "static/media/icon-brand-recognition.c349d3b6.svg";